module.exports = __webpack_public_path__ + "../resources/img/qr-ios-pro.9038361e.png";